module.exports = __webpack_public_path__ + "img/leftBg.c56e7a4f.png";